import { useTranslation } from 'react-i18next'
import TeamSocials from './TeamSocials';
import acuPhoto from '../../assets/images/team/acu.png';
import dantePhoto from '../../assets/images/team/dante.png';

const acu = {
    portfolio: 'https://agusdellaquila.vercel.app/',
    github: 'https://github.com/agusdellaquila',
    linkedin: 'https://www.linkedin.com/in/agustin-dell-aquila-a5b2451b2/',
    tags: ['team_skill_graphicdesign', 'React', 'Tailwind', 'Java', 'SQL', 'Webflow', 'Figma', 'SEO', 'team_skill_english', 'team_skill_fullstack']
}

const dante = {
    portfolio: 'https://dante-terranova.vercel.app/',
    github: 'https://github.com/BinaryJuan',
    linkedin: 'https://www.linkedin.com/in/dante-terranova-2383361a4/',
    tags: ['React', 'Tailwind', 'Java', 'SQL', 'Photoshop','team_skill_photography', 'Figma', 'team_skill_english', 'team_skill_fullstack']
}

const Team = () => {
    const { t } = useTranslation()

    return (
        <div className='mb-20'>
            <div className="px-10">
                <h1 className="h1-macro no-selection mt-16">{ t('team_title') }</h1>

                <div className='mt-10 flex flex-col gap-y-6 xl:flex-row xl:gap-x-20 xl:justify-center xl:pr-6'>
                    <p className="text-gray-600 lg:w-almost xl:w-9/12">
                        { t('team_p1') } 
                        {/* <span className='font-semibold'>binary team</span> */}
                    </p>
                    <p className="text-gray-600 lg:w-almost xl:w-11/12">
                        { t('team_p2') } 
                        {/* <span className='font-semibold'>exceed their clients' expectations</span>. */}
                    </p>
                </div>

                <div className="flex flex-col items-center gap-y-20 sm:flex-row md:flex-row lg:flex-row xl:flex-row justify-evenly mt-14">
                    <div className="sm:w-3/12 md:w-3/12 lg:w-3/12 xl:w-3/12">
                        <img src={acuPhoto} alt="team 1" className="w-full h-auto object-fit" />
                        <p className='text-center text-2xl mt-6'>Agustín Dell' Aquila</p>
                        <p className='text-center font-light mt-2'>{ t('team_position_acu') }</p>
                        <div className='w-full flex flex-wrap gap-x-2 gap-y-2 mt-4'>
                            {acu.tags.map((tag, index) => {
                                return (
                                    <p className='bg-gray-200 hover:bg-indigo-300 w-max p-1 rounded-md text-center text-xs grow no-selection' key={index}>{ t(tag) }</p>
                                )
                            })}
                        </div>
                        <TeamSocials socials={acu} />
                    </div>
                    <div className="sm:w-3/12 md:w-3/12 lg:w-3/12 xl:w-3/12">
                        <img src={dantePhoto} alt="team 2" className="w-full h-auto object-cover" />
                        <p className='text-center text-2xl mt-6'>Dante Terranova</p>
                        <p className='text-center font-light mt-2'>{ t('team_position_dante') }</p>
                        <div className='w-full flex flex-wrap gap-x-2 gap-y-2 justify-center mt-4'>
                            {dante.tags.map((tag, index) => {
                                return (
                                    <p className='bg-gray-200 hover:bg-indigo-300 w-max p-1 rounded-md text-center text-xs grow no-selection' key={index}>{ t(tag) }</p>
                                )
                            })}
                        </div>
                        <TeamSocials socials={dante} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Team;